<template>
    <div class="settings-card" @click="onEdit">
        <div class="col">
            <Icon :name="setting.icon" :size="20" />
            <div class="setting">
                <div v-show="setting.value" class="copy-l value">
                    <span v-if="$t(`${type}.settings.${setting.name}.prefix`)" class="prefix">
                        {{ $t(`${type}.settings.${setting.name}.prefix`) }}
                    </span>
                    <span v-if="setting.type === 'boolean'">
                        {{ $t(`${type}.settings.${setting.name}.empty`) }}
                    </span>
                    <span v-if="setting.type !== 'boolean'">
                        {{ setting.value }}
                    </span>
                    <span v-if="$t(`${type}.settings.${setting.name}.suffix`)" class="suffix">
                        {{ $t(`${type}.settings.${setting.name}.suffix`) }}
                    </span>
                </div>
                <div v-if="setting.value" class="copy-m description">
                    {{ $t(`${type}.settings.${setting.name}.description`) }}
                </div>
                <div v-else class="copy-m">{{ $t(`${type}.settings.${setting.name}.empty`) }}</div>
            </div>
        </div>
        <div v-if="setting.type !== 'boolean' && setting.value" class="edit copy-s bold">{{ $t('general.edit') }}</div>
        <div v-if="!setting.value && setting.type !== 'boolean'" class="edit copy-s bold">
            {{ $t(`${type}.settings.${setting.name}.action`) }}
        </div>
        <LargeSwitch v-if="setting.type === 'boolean'" :active="setting.value" @toggle="saveToggle(setting.value)" />
    </div>
</template>

<script>
import Icon from '@/components/Icon'
import LargeSwitch from '@/components/LargeSwitch'
import gql from 'graphql-tag'

export default {
    name: 'SettingsCard',
    components: {
        Icon,
        LargeSwitch,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        setting: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onEdit() {
            if (this.setting.type === 'boolean') {
                return
            }
            this.$emit('edit')
        },
        async saveToggle(value = false) {
            this.modalOpen = false
            let name = this.setting.name
            let venueInput = {}
            venueInput[name] = !value

            let venueId = this.$route.params.id

            await this.$apollo
                .mutate({
                    mutation: gql`mutation($id: ID!, $value: PartialVenueInput!) {
                      updateVenue(id: $id, input: $value) {
                        ${this.setting.name}
                      }
                    }
                    `,
                    variables: {
                        id: venueId,
                        value: venueInput,
                    },
                })
                .catch(() => {
                    this.$pm.createToast('error', this.$t('errors.settings_could_not_be_saved'))
                })

            this.$emit('reload')
        },
    },
}
</script>

<style scoped lang="sass">
.settings-card
    border-radius: 12px
    padding: $s $m
    display: flex
    justify-content: space-between
    cursor: pointer

    &:hover
        background: $gray-2

        .edit
            color: $primary-2

        .icon

            &::v-deep
                svg
                    path
                        stroke: $neutral-3


    .col
        display: flex
        align-items: center

        .icon
            margin-right: $s
            min-width: 20px

        .setting
            .value
                color: $neutral-4
                word-break: break-all

            .copy-m
                color: $neutral-2

    .edit
        margin-top: 6px
        color: $neutral-2





    //
</style>
